import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PageTitle } from "../../../../sdb/layout/core/PageData";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import { useLocation, useParams } from "react-router-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { styled } from "@mui/material/styles";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Button from "@mui/material/Button";
import HighchartsComponent from "../../../../chartnew";
import { getData } from "./request";
const options = ["Edit Device", "Device"];
const ITEM_HEIGHT = 48;

const DemoPaper = styled(Paper)(({ theme }) => ({
  width: 176,
  height: 70,
  padding: theme.spacing(1),
  ...theme.typography.body2,
  textAlign: "center",
}));

// Reusable component for each index card
const IndexCard = ({
  title,
  value,
  unit,
}: {
  title: string;
  value: number;
  unit: string;
}) => {
  return (
      <DemoPaper square={false} elevation={7}>
        <Box display="flex" justifyContent="space-between">
          <Typography fontWeight={600} fontSize={14}>
            {title}
          </Typography>
          <HelpOutlineIcon />
        </Box>
        <Box sx={{ position: "absolute" }}>
          <Typography variant="h4" fontWeight={560} sx={{ color: "orange" }}>
            {value} <span style={{ fontSize: 14, color: "black" }}>{unit}</span>
          </Typography>
        </Box>
      </DemoPaper>
  );
};

export const DeviceAction = () => {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const params = useParams();
  const devicename = params.id;
  const location = useLocation();
  const { item } = location.state || {}; // Destructure the passed state

  console.log(item); 


  const [chartData, setChartData] = useState<any>(null);

  const createChartOptions = (title: string, data: number[], unit: string) => ({
    chart: { type: "line" },
    title: { text: title },
    xAxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"], // Dummy categories, replace with your real data
    },
    yAxis: {
      title: { text: unit },
      tickInterval: 5, 
      min: 0,          
      max: 30,       
    },
    series: [
      {
        name: title,
        data: data.length ? data : [0], 
      },
    ],
  });
  
  

useEffect(() => {
  if (item && item.data) {
    const formattedData = {
      temperature: [item.data.temperature],
      humidity: [item.data.humidity],
      pm25: [item.data.pm25],
      pm10: [item.data.pm10],
      co2: [item.data.co2],
      tvoc: [item.data.tvoc],
      restviralindex: [item.data.restviralindex],
    };
    setChartData(formattedData); 
  }
}, [item]);
  return (
    <Box sx={{ fontFamily: "Inter" }}>
      <Box>
        <PageTitle
          breadcrumbs={[
            {
              title: (
                <span
                  className="breadcrumb-title"
                  style={{
                    display: "inline-block",
                    color: "inherit",
                    textDecoration: "none",
                    backgroundColor: "transparent",
                    borderRadius: "3px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.textDecoration = "underline";
                    e.currentTarget.style.backgroundColor = "#f0f8ff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "inherit";
                    e.currentTarget.style.textDecoration = "none";
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  IAQ Management
                </span>
              ),
              path: "/modules/device-management",
              isSeparator: false,
              isActive: false,
            },
          ]}
        >
          Device Action
        </PageTitle>
      </Box>

      <Box display="flex" justifyContent="space-between">
        <Box>
          <Typography variant="h6">Device Name</Typography>
          <Typography fontSize={23} fontWeight={600}>
            {devicename || "Unknown Device"}
          </Typography>
        </Box>
        <Box>
          <Avatar
            sx={{ bgcolor: "lightgrey", borderRadius: "5px " }}
            variant="square"
          >
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              slotProps={{
                paper: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: "20ch",
                  },
                },
              }}
            >
              {options.map((option) => (
                <MenuItem
                  key={option}
                  selected={option === "Pyxis"}
                  onClick={handleClose}
                >
                  {option}
                </MenuItem>
              ))}
            </Menu>
          </Avatar>
        </Box>
      </Box>

      <Divider sx={{ border: "1px solid grey", mt: 1 }} />

      <Box>
        <Box
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={1}
          sx={{ mt: 3 }}
        >
          <IndexCard title="Overall Index" value={62} unit="us" />
          <IndexCard title="CO2" value={400} unit="ppm" />
          <IndexCard title="PM10" value={12} unit="µg/m³" />
          <IndexCard title="PM2.5" value={12} unit="µg/m³" />
          <IndexCard title="TVOC" value={22} unit="ppb" />
          <IndexCard title="REST  Viral Index" value={3} unit="%" />
          <IndexCard title="Temperature" value={45} unit="%" />
        </Box>
      </Box>
      <Box>
        <Box
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={1}
          sx={{ mt: 3 }}
        >
          <Box>
            <Typography variant="h6" sx={{ color: "grey" }}>
              Last Updated  Today
            </Typography>
            <Typography fontSize={20} fontWeight={600}>
              Air Quality History
            </Typography>
          </Box>
          <Box>
            <Avatar
              sx={{ bgcolor: "lightgrey", borderRadius: "5px " }}
              variant="square"
            >
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                  paper: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: "20ch",
                    },
                  },
                }}
              >
                {options.map((option) => (
                  <MenuItem
                    key={option}
                    selected={option === "Pyxis"}
                    onClick={handleClose}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </Avatar>
          </Box>
        </Box>

        <Box>
          <Box sx={{ fontFamily: "Inter" }}>
            {/* <Box>
        <Typography variant="h6">Device Name</Typography>
        <Typography fontSize={23} fontWeight={600}>
          {devicename || "Unknown Device"}
        </Typography>
      </Box> */}
            {chartData && (
              <Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  gap={2}
                  sx={{ mt: 3 }}
                >
                  {/* Temperature Chart */}
                  <Box width="100%">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={createChartOptions(
                        "Temperature",
                        chartData.temperature || [],
                        "°C"
                      )}
                    />
                  </Box>

                  {/* Humidity Chart */}
                  <Box width="100%">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={createChartOptions(
                        "Humidity",
                        chartData.humidity || [],
                        "%"
                      )}
                    />
                  </Box>

                  {/* PM2.5 Chart */}
                  <Box width="100%">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={createChartOptions(
                        "PM2.5",
                        chartData.pm25 || [],
                        "µg/m³"
                      )}
                    />
                  </Box>

                  {/* PM10 Chart */}
                  <Box width="100%">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={createChartOptions(
                        "PM10",
                        chartData.pm10 || [],
                        "µg/m³"
                      )}
                    />
                  </Box>

                  {/* CO2 Chart */}
                  <Box width="100%">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={createChartOptions(
                        "CO2",
                        chartData.co2 || [],
                        "ppm"
                      )}
                    />
                  </Box>

                  {/* TVOC Chart */}
                  <Box width="100%">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={createChartOptions(
                        "TVOC",
                        chartData.tvoc || [],
                        "ppb"
                      )}
                    />
                  </Box>

                  {/* Rest Viral Index Chart */}
                  <Box width="100%">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={createChartOptions(
                        "Rest Viral Index",
                        chartData.restviralindex || [],
                        "%"
                      )}
                    />
                  </Box>
                </Box>
              </Box>
            )}
          </Box>{" "}
        </Box>
      </Box>
    </Box>
  );
};
